import { useLazyQuery } from '@apollo/client'
import { TestsResultsAnalytics, TestsResultsAnalyticsVariables } from '../../types'
import { TESTS_RESULTS_ANALYTICS } from './operations'

export const useTestsResultsAnalytics = () => {
  const testAnalyticsQuery = useLazyQuery<TestsResultsAnalytics, TestsResultsAnalyticsVariables>(
    TESTS_RESULTS_ANALYTICS
  )

  return testAnalyticsQuery
}
